import { FieldError } from 'react-hook-form';
import styled, { css } from 'styled-components';

import variables from '../../styles/variables';
import Input from '../elements/Input/Input';

export const FormWrapper = styled.div`
  flex-basis: 30%;
  position: relative;
  align-items: flex-start;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  .wrapper {
    padding: 25px;
    @media screen and (max-width: 414px) {
      padding: 0;
    }
  }
`;

export const FormTitle = styled.h2`
  color: #eb0000;
  width: 100%;
  font-size: 40px;
  font-weight: 600;
  line-height: 46px;
`;

export const FormDescription = styled.p`
  width: 100%;
  margin-bottom: 2.5rem;
`;

export const StyledForm = styled.form`
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FieldSet = styled.fieldset`
  width: 100%;
  float: left;
  margin-bottom: 1rem;
  border: none;
  display: flex;
  flex-direction: column;
  &.half {
    width: 45%;
    @media screen and (max-width: 1024px) {
      width: 100%;
      clear: both;
    }
  }
  &.optIn {
    label {
      display: flex;
      align-items: center;
      line-height: 1.2;
      position: relative;
      user-select: none;
      padding-left: 30px;
      cursor: pointer;
      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        left: 0px;
        top: 0;
        min-height: 20px;
        height: 100%;
        margin: 0;
        z-index: 1;
        &:checked ~ .checkmark:after {
          display: block;
        }
      }
      input:focus-visible ~ .checkmark {
        outline: 5px auto Highlight;
        outline: 5px auto -webkit-focus-ring-color;
      }
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: transparent;
        border: 2px solid #b4b7bd;
        &:after {
          content: '';
          position: absolute;
          display: none;
          left: 4px;
          top: 0px;
          width: 7px;
          height: 13px;
          border: solid #eb0000;
          border-width: 0 3px 3px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
  &.submit {
    margin: 1rem auto 2rem;
  }
  &.recaptcha {
    margin: 0.5rem auto 1rem;
    iframe {
      margin-bottom: 0;
    }
  }
  &.location {
    margin-bottom: 1rem;
  }
  label {
    float: left;
  }
`;

export const InputField = styled(Input)<{
  valid?: boolean | FieldError;
  error?: FieldError;
}>`
  padding-left: 1rem;
  height: 50px;
  width: 100%;
  margin: 0.5rem auto;
  ::-webkit-input-placeholder {
    color: #6b6b6b;
    opacity: 1;
  }
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 400ms ease;
  ${({ valid }) => valid && validFieldMixin}
  ${({ error }) => error && errorFieldMixin}
`;

export const Button = styled.button`
  height: 50px;
  width: 100%;
  max-width: 300px;
  border-radius: 25px;
  border: none;
  margin: 0.5rem auto;
  background-color: ${variables.colorRed};
  color: ${variables.colorWhite};
  font-size: 1rem;
  box-shadow: 0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 400ms ease;
  ${(props) => (props.disabled ? 'pointer-events: none;' : null)}

  &:hover {
    background-color: ${variables.colorBlack};
    transition: all 400ms ease;
  }

  &:disabled {
    background-color: ${variables.colorBlack};
    transition: all 400ms ease;
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const Spinner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorMsg = styled.div`
  color: ${variables.colorRed};
  font-size: 12px;
  clear: both;

  &.recaptcha {
    margin-top: 0.5rem;
  }
`;

export const Submitted = styled.div`
  margin: 0 auto;
  width: 100%;
  display: table-cell;
  vertical-align: middle;

  @media screen and (max-width: 768px) {
    height: auto;
  }

  h1 {
    width: 100%;
    line-height: 4.5rem;

    @media screen and (max-width: 768px) {
      max-width: 100%;
      padding-left: 0;
    }

    @media screen and (max-width: 640px) {
      line-height: 2.5rem;
    }
  }

  p {
    margin: 2rem 0;
    font-size: 1.125rem;
    line-height: 2rem;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }

  img {
    width: 50px;
  }
`;

export const Headline = styled.h1`
  color: ${variables.colorRed};
  font-size: 3.9375rem;
  font-weight: bold;
  letter-spacing: -0.85px;
  text-transform: none;
  line-height: 3.8125rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 1024px) {
    font-size: 3rem;
    line-height: 3.4rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 2.1875rem;
    line-height: 2.6rem;
    padding: 0 1.25rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.875rem;
    line-height: 2rem;
  }
`;

export const SubHeadline = styled.p``;

export const CheckMarkImg = styled.img``;

const errorFieldMixin = css`
  border: 1px solid ${variables.colorRed};
  transition: all 400ms ease;
`;

const validFieldMixin = css`
  border: 1px solid green;
  transition: all 400ms ease;
`;

export const LoadingWrapper = styled.div`
  margin: 40px 0;
  width: 100%;
  height: 300px;
  display: flex;

  @media screen and (max-width: 768px) {
    height: auto;
  }
`;

export const ErrorSection = styled.div`
  color: ${variables.colorRed};
`;

export const DropdownWrapper = styled.div<{ selectedValue?: string }>`
  position: relative;
  margin-top: 4px;
  button {
    width: 100%;
    background: transparent;
    color: ${({ selectedValue }) => selectedValue ? 'black' : variables.colorGreyDark};
    border-color: #d3d3d3;
  }
`;

export const CheckboxLabel = styled.label`
  font-size: 14px;
`;
